import React from "react";
import { Button } from '@progress/kendo-react-buttons';
import { useFormikContext } from 'formik';
import {buttonThemeColors} from "../../base/Button/Button.jsx";

export const CancelButton = ({ children = 'Cancel', themeColor = buttonThemeColors.error, disabled, ...otherProps }) => {
    const { isSubmitting } = useFormikContext();

    return (
        <Button
            type="button"
            themeColor={themeColor}
            disabled={isSubmitting || disabled}
            {...otherProps}
        >
            {children}
        </Button>
    );
};
